import React from "react";

const BErrorIndicator = () => {
  return (
    <div className="p-6">
      <div className="bg-white rounded shadow-md mt-6 w-full">
        <div className="p-10 font-bold text-lg text-center">No data yet</div>
      </div>
    </div>
  );
};

export default BErrorIndicator;
